export enum LedgerAccountKind {
  'UNKNOWN' = 0,
  'INVESTMENT_AND_CAPITAL_ACCOUNTS' = 1,
  'FINANCIAL_AND_PERSONAL_ACCOUNTS' = 2,
  'ACCRUAL_ACCOUNTS' = 3,
  'OPERATING_EXPENSES' = 4,
  'STOCKS_OF_PRODUCTS' = 5,
  'REVENUE_ACCOUNTS' = 6,
  'LECTURE_ACCOUNTS_STATISTICAL_ACCOUNTS' = 7,
  'CASH_DISCOUNT_INCOMING_ACCOUNT' = 8,
  'CASH_DISCOUNT_OUTGOING_ACCOUNT' = 9,
  'GENERAL_LEDGER_ACCOUNT' = 10,
}

export const LedgerAccountKindMap = Object.keys(LedgerAccountKind).filter(
  (x) => !isNaN(Number(x))
);
